import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { EmployerService } from '@/infra/services/employer';

interface CreateEmployerParams {
	name: string;
	company_id: string;
	organization_id: string;
}

const Service = EmployerService.getInstance();

export const useCreateEmployer = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: CreateEmployerParams) => Service.create(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_EMPLOYER]);
			message.success(I18n.get('Employer created successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on create employer'));
		}
	});
};
